import React, { useContext } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

import { Logo } from '../atom/Logo';
import Icon from '../atom/Icon';
import { Flex } from '../atom/Layout';
import { Drawer } from './Drawer';

import * as PATH from '../../../lib/routes/path';
import DrawerContext from '../../../modules/contexts/DrawerContext';
import { breakpoint } from '../../../lib/style/ThemeStyle';

const Header = () => {
  const {
    state: { drawer },
    actions: { onDrawer },
  } = useContext(DrawerContext);

  const history = useHistory();
  return (
    <>
      {drawer && <Drawer />}
      <Container>
        <MainHeader justifyContent="space-between">
          <Logo onClick={() => history.push(PATH.HOME)} />
          <Icon iconName="menu" onClick={onDrawer} />
        </MainHeader>
      </Container>
    </>
  );
};

export default React.memo(Header);

const Container = styled(Flex)`
  position: fixed;
  z-index: 101;
  width: 100%;
  max-width: ${breakpoint}px;
  background: ${(props) => props.theme.color.background};
`;

const MainHeader = styled(Flex)`
  color: ${(props) => props.theme.color.orangePink};
  padding: 0.6875rem 1.25rem;
  box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px 0px;
  width: 100%;
`;
